import {
  createSelectOptionColorPicker,
  SELECT_OPTION_COLOR_BY_NAME,
  SELECT_OPTION_COLORS,
  SELECT_OPTION_LEGACY_COLOR_MAP,
  type SelectOptionColor,
} from '@streamlain/database-identity';
import { cssVarV2 } from '@streamlain/theme/v2';

export type { SelectOptionColor };

export const selectOptionColors: SelectOptionColor[] = [
  ...SELECT_OPTION_COLORS,
];

const chipLabelColorMap: Record<string, string> = {
  [cssVarV2('chip/label/blue')]: SELECT_OPTION_COLOR_BY_NAME.Blue,
  [cssVarV2('chip/label/orange')]: SELECT_OPTION_COLOR_BY_NAME.Orange,
  [cssVarV2('chip/label/green')]: SELECT_OPTION_COLOR_BY_NAME.Green,
  [cssVarV2('chip/label/magenta')]: SELECT_OPTION_COLOR_BY_NAME.Magenta,
  [cssVarV2('chip/label/purple')]: SELECT_OPTION_COLOR_BY_NAME.Purple,
  [cssVarV2('chip/label/red')]: SELECT_OPTION_COLOR_BY_NAME.Red,
  [cssVarV2('chip/label/teal')]: SELECT_OPTION_COLOR_BY_NAME.Teal,
  [cssVarV2('chip/label/yellow')]: SELECT_OPTION_COLOR_BY_NAME.Yellow,
  [cssVarV2('chip/label/grey')]: SELECT_OPTION_COLOR_BY_NAME.Grey,
};

// Legacy chip-label tokens that failed the contrast bar (white text on
// near-white/ultra-light backgrounds was unreadable). Rewritten on read
// so old data keeps rendering without an invasive Y.Doc migration: the
// "White" option ships as the saturated grey chip instead.
const lowContrastTokenMap: Record<string, string> = {
  'var(--streamlain-v2-chip-label-white)': SELECT_OPTION_COLOR_BY_NAME.Grey,
  'var(--streamlain-tag-white)': SELECT_OPTION_COLOR_BY_NAME.Grey,
};

export const getColorByColor = (color: string) => {
  // Migrate legacy --affine- CSS variable references stored in document data
  if (color.includes('--affine-')) {
    color = color.replace(/--affine-/g, '--streamlain-');
  }
  if (color.startsWith('--streamlain-tag')) {
    color = SELECT_OPTION_LEGACY_COLOR_MAP[color] ?? color;
  }
  return lowContrastTokenMap[color] ?? chipLabelColorMap[color] ?? color;
};

export const getTagColor = createSelectOptionColorPicker();
